import { Component, computed, inject } from '@angular/core';
import { FileTableComponent, BreadcrumbListComponent } from '@r1-compass-library/components';
import { AppConstants } from '../../app.constants';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TemplateCriteriaListStore } from '../store/template-criteria-list.store';
import { TemplateCriteria } from '@r1-compass-library/models';
import { TemplateCriteriaFolderService, TemplateCriteriaService } from '@r1-compass-library/services';
import { AssetListComponent } from '../../asset-list.component';

@Component({
    selector: 'r1-compass-app-template-criteria-list',
    imports: [BreadcrumbListComponent, FileTableComponent, MatButtonModule, MatMenuModule],
    templateUrl: './template-criteria-list.component.html',
    styleUrl: './template-criteria-list.component.scss',
})
export class TemplateCriteriaListComponent extends AssetListComponent<
    TemplateCriteria,
    TemplateCriteriaService,
    TemplateCriteriaFolderService,
    TemplateCriteriaListStore
> {
    override EDIT_ASSET_PATH: string = AppConstants.TemplateCriteriaDefinitionComponent.path;
    override BASE_PATH = '/template-criteria';

    constructor() {
        super(
            inject(TemplateCriteriaListStore),
            inject(TemplateCriteriaService),
            inject(TemplateCriteriaFolderService)
        );
        this.columns = AppConstants.folderNameColumnsForAssets;
    }

    override sortedFileTableEntries = computed(() =>
        this.assetListSortingService.defaultSortWithEnabled(this.vm().contentWithActions)
    );
}
